import styled from '@emotion/styled';
import { useRef } from 'react';
import { useSelect } from 'react-aria';
import { useSelectState, Item, Section } from 'react-stately';

import { useI18n } from '../../../hooks/useI18nFormatters';

import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

import { AnimationRemain } from '../../../components/animation/AnimationRemain';
import { GradientButtonRound } from '../../../components/buttons/GradientButtonRound';

import { resolutions } from './resolutions';
import { ResolutionSelectListBox } from './ResolutionSelectListBox';

export function ResolutionSelect(props) {
  const { i18n } = useI18n();

  return (
    <ListBox
      label="Resolution Select"
      onSelectionChange={props.onSelectionChange}
      selectedKey={props.selectedKey}
      items={resolutions}
    >
      {(item) => {
        const { id, children } = item;

        return (
          <Section key={id} title={id} aria-label={id}>
            {children.map((resolution) => {
              return (
                <Item key={resolution.id} resolution={resolution}>
                  {i18n.messageFormatter(`insights.resolutions.${resolution.id}`)}
                </Item>
              );
            })}
          </Section>
        );
      }}
    </ListBox>
  );
}

export function ListBox(props) {
  const buttonRef = useRef();

  const sharedProps = {
    children: props.children,
    onSelectionChange: props.onSelectionChange,
    selectedKey: props.selectedKey,
    items: props.items,
    label: props.label,
    'aria-label': props.label,
  };

  const selectState = useSelectState({
    ...sharedProps,
  });

  const select = useSelect(
    {
      ...sharedProps,
    },
    selectState,
    buttonRef,
  );

  return (
    <ResolutionSelect.Root>
      <input type="hidden" name={props.name} value={selectState.selectedKey} />
      <GradientButtonRound
        {...select.triggerProps}
        ref={buttonRef}
        title={selectState.selectedItem?.rendered}
      >
        <GradientButtonRound.Icon
          source={glyph.core.clockFill}
          color={theme.color.white}
          size={theme.icon.size_medium}
        />
        <GradientButtonRound.Text {...select.valueProps}>
          {selectState.selectedItem?.rendered}
        </GradientButtonRound.Text>
      </GradientButtonRound>

      <AnimationRemain condition={selectState.isOpen} delay={200}>
        {(animationRemainProps) => {
          return (
            <ResolutionSelectListBox
              menuProps={select.menuProps}
              selectState={selectState}
              targetRef={buttonRef}
              animationRemainProps={animationRemainProps}
            />
          );
        }}
      </AnimationRemain>
    </ResolutionSelect.Root>
  );
}

ResolutionSelect.Root = styled.div`
  display: inline-block;
`;
